/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { TimezoneFieldDisplay } from "./display";
import { TimezoneFieldEdit } from "./edit";

const TimezoneField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <TimezoneFieldDisplay />,
        editComponent: <TimezoneFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
TimezoneField.displayName = "TimezoneField";
export { TimezoneField };
